import { render } from "./SuperAgents.vue?vue&type=template&id=2c49f8c6"
import script from "./SuperAgents.vue?vue&type=script&lang=js"
export * from "./SuperAgents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__